module.exports = __webpack_public_path__ + "static/media/CabinetDoorCorner_After.430b42df.jpg";